import script from "./SidenavCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavCard.vue?vue&type=script&setup=true&lang=js"

import "./SidenavCard.vue?vue&type=style&index=0&id=2ff4ec96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff4ec96"]])

export default __exports__